export const useBusEvent = (eventName: string, callback: Function) => {
    onMounted(() => {
        useNuxtApp().$mitt.on(eventName, callback)
    })
    onUnmounted(() => {
        useNuxtApp().$mitt.off(eventName, callback)
    })
}
